// modules
import React, {useEffect, useState} from "react";
import "../styles/Heatmap.scss";
import ApiService from "../services/ApiService.js";
import { useAuth } from "react-oidc-context";

const Heatmap = ({releaseId}) => {

  const auth = useAuth();
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    console.log("release id : ",releaseId)
    const fetchImage = async () => {
      const accessToken = auth.user?.access_token;
      try {
        const src = await ApiService.getHeatmapImageByReleaseId(releaseId, accessToken);
        setImageSrc(src);
      } catch (err) {
        console.error("Failed to load heatmap image:", err);
      }
    }; 

    if(releaseId !== undefined){fetchImage();}
    
  }, [auth.isAuthenticated, auth.user,releaseId, ApiService]);


  return (
    <div className="hm-main-container">
      {imageSrc ? (
        <img className="hm-img" src={imageSrc} alt="Heatmap" />
      ) : (
        <p style={{color: "white"}}>Loading heatmap image...</p>
      )}
    </div>
  );
};

export default Heatmap;
